import { Product } from '../../enums/booking';
import { Booking, BusBooking, FlightBooking, HotelBooking, TrainBooking } from '../BookingCard/index.types';

export const getBookingInfo = (booking?: Booking) => {
    if (!booking) return 'General Query';

    let text = '';

    switch (booking.product.toLowerCase()) {
        case Product.BUS:
        case Product.CTKT_TRAIN:
        case Product.FLIGHT_PRICE_LOCK:
        case Product.FLIGHT:
        case Product.TRAIN: {
            const { origin, destination, travelDate } = booking as BusBooking | FlightBooking | TrainBooking;
            text = `${origin} - ${destination} • ${travelDate}`;
            break;
        }

        case Product.HOTEL: {
            const { name, checkInDate } = booking as HotelBooking;
            text = `${name} • ${checkInDate}`;
            break;
        }

        default:
            break;
    }

    return text;
};
